module.exports = __webpack_public_path__ + "img/logo-big.40277bb9.png";